export const initialState = {
  categories: {
    next: null,
    loading: false,
    value: [],
    initialised: false,
  },
  selectedCategory: {},
  productsColumns: [
    {
      id: 'supplier',
      numeric: false,
      disablePadding: true,
      label: 'Supplier',
      align: 'left',
    },
    {
      id: 'product',
      numeric: false,
      disablePadding: true,
      label: 'Product',
      align: 'left',
    },
    {
      id: 'price',
      numeric: false,
      disablePadding: true,
      label: 'Price',
      align: 'center',
    },
    {
      id: 'action',
      numeric: false,
      disablePadding: true,
      label: 'Add',
      align: 'center',
    },
  ],
  products: {
    next: null,
    loading: true,
    value: [],
    initialised: true,
  },
  selectedProduct: {},
  quoteColumns: [
    {
      id: 'category',
      numeric: false,
      disablePadding: true,
      label: 'Category',
      align: 'left',
    },
    {
      id: 'supplier',
      numeric: false,
      disablePadding: true,
      label: 'Supplier',
      align: 'left',
    },
    {
      id: 'description',
      numeric: false,
      disablePadding: true,
      label: 'Description',
      align: 'left',
    },
    {
      id: 'poNumber',
      numeric: false,
      disablePadding: true,
      label: 'PO No.',
      align: 'center',
    },
    {
      id: 'price',
      numeric: false,
      disablePadding: true,
      label: 'Price',
      align: 'center',
    },
    {
      id: 'info',
      numeric: false,
      disablePadding: true,
      label: 'Info',
      align: 'center',
    },
    {
      id: 'sendPO',
      numeric: false,
      disablePadding: true,
      label: 'Send PO',
      align: 'center',
    },
    // {
    //   id: 'paid',
    //   numeric: false,
    //   disablePadding: true,
    //   label: 'Paid',
    //   align: 'center',
    // },
    {
      id: 'delete',
      numeric: false,
      disablePadding: true,
      label: 'Delete',
      align: 'center',
    },
  ],
  newQuoteSetForm: {
    loading: false,
  },
  newQuoteForm: {
    loading: false,
  },
  selectedQuoteSet: {},
  selectedQuoteSetProperty: {},
  quotes: {
    next: null,
    loading: false,
    value: [],
    initialised: false,
  },
  quoteConversations: {
    loading: false,
    value: [],
  },
  quoteStatus: {
    loading: false,
    value: [],
  },
  selectedQuote: {},
  addQuoteProduct: {
    loading: false,
    defaultSelectedQuote: '',
  },
  selectedQuoteProduct: {
    sendTogether: true,
    value: {},
  },
  generateQuoteForm: {
    loading: false,
    sales_method: null,
    vendor_name: null,
    organisation_list: [],
    selected_organisation_id: null,
  },
  purchaseEmailData: {},
  sendPurchaseOrderForm: {
    loading: false,
  },
  savedQuotes: {
    next: null,
    loading: true,
    value: [],
  },
  saveQuoteForm: {
    loading: false,
  },
  loadQuoteForm: {
    loading: false,
  },
  quoteOrganizations: {
    loading: false,
    value: [],
  },
  importedAttachments: [],
  quoteExportLoading: false,
  quoteExportDownloadLoading: false,
};
